unit UFramePermissoesUsuario;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, WEBLib.DBCtrls, Vcl.Controls, WEBLib.ExtCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, UUtils, UWeb.Enum, System.StrUtils,
  UConstantes, XData.Web.Client, System.Generics.Collections, WEBLib.WebCtrls;

type
  TFramePermissoesUsuario = class(TFrame)
    pnlPermissoesFacil: TPanel;
    tblPermissoesFacilSistemas: TDBTableControl;
    pnlPermissoesService: TPanel;
    tblPermissoesService: TDBTableControl;
    cdsPermissoesService: TXDataWebDataSet;
    cdsPermissoesServiceid: TIntegerField;
    cdsPermissoesServicevisualizar: TBooleanField;
    cdsPermissoesServiceinserir: TBooleanField;
    cdsPermissoesServicealterar: TBooleanField;
    cdsPermissoesServiceexcluir: TBooleanField;
    cdsPermissoesServicetabela_sistematabela: TStringField;
    cdsPermissoesServiceusuario_id: TIntegerField;
    cdsPermissoesServicetabela_sistematabela_origem: TIntegerField;
    dtsPermissoesService: TDataSource;
    cdsPermissoesFacilSistemas: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    BooleanField1: TBooleanField;
    BooleanField2: TBooleanField;
    BooleanField3: TBooleanField;
    BooleanField4: TBooleanField;
    StringField1: TStringField;
    IntegerField2: TIntegerField;
    cdsPermissoesFacilSistemastabela_sistematabela_origem: TIntegerField;
    dtsPermissoesFacilSistemas: TDataSource;
    btnSalvarPermissoes: TButton;
    edtPesquisarFacilSistemas: TEdit;
    edtPesquisarService: TEdit;
    btnService: TButton;
    btnFacilSistemas: TButton;
    lblDescricaoPermissao: TLabel;
    pnlWhatsapp: TPanel;
    tblPermissoesWhatsapp: TDBTableControl;
    cdsPermissoesWhatsapp: TXDataWebDataSet;
    IntegerField3: TIntegerField;
    BooleanField5: TBooleanField;
    BooleanField6: TBooleanField;
    BooleanField7: TBooleanField;
    BooleanField8: TBooleanField;
    StringField2: TStringField;
    IntegerField4: TIntegerField;
    IntegerField5: TIntegerField;
    dtsPermissoesWhatsapp: TDataSource;
    btnWhatsapp: TButton;
    pnlMensagens: TPanel;
    tblPermissoesMensagens: TDBTableControl;
    cdsPermissoesMensagens: TXDataWebDataSet;
    IntegerField6: TIntegerField;
    BooleanField9: TBooleanField;
    BooleanField10: TBooleanField;
    BooleanField11: TBooleanField;
    BooleanField12: TBooleanField;
    StringField3: TStringField;
    IntegerField7: TIntegerField;
    IntegerField8: TIntegerField;
    dtsPermissoesMensagens: TDataSource;
    btnMensagens: TButton;
    tmrConsultaService: TTimer;
    tmrConsultaFacilSistemas: TTimer;
    XDataClientSalvarPermissoes: TXDataWebClient;
    cdsPermissoesServicetabela_id: TIntegerField;
    cdsPermissoesFacilSistemastabela_id: TIntegerField;
    cdsPermissoesWhatsapptabela_id: TIntegerField;
    cdsPermissoesMensagenstabela_id: TIntegerField;
    procedure TabelaGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure TabelaGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField;
      AValue: string; var AClassName: string);
    procedure TabelaGetCellData(Sender: TObject; ACol, ARow: Integer; AField: TField;
      var AValue: string);
    procedure btnServiceClick(Sender: TObject);
    procedure btnFacilSistemasClick(Sender: TObject);
    procedure cdsPermissoesServiceAfterOpen(DataSet: TDataSet);
    procedure cdsPermissoesFacilSistemasAfterOpen(DataSet: TDataSet);
    procedure cdsPermissoesWhatsappAfterOpen(DataSet: TDataSet);
    procedure btnWhatsappClick(Sender: TObject);
    procedure cdsPermissoesMensagensAfterOpen(DataSet: TDataSet);
    procedure btnMensagensClick(Sender: TObject);
    procedure TabelaClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure cdsPermissoesServiceFilterRecord(DataSet: TDataSet;
      var Accept: Boolean);
    procedure tmrConsultaServiceTimer(Sender: TObject);
    procedure edtPesquisarServiceKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edtPesquisarServiceKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaFacilSistemasTimer(Sender: TObject);
    procedure cdsPermissoesFacilSistemasFilterRecord(DataSet: TDataSet;
      var Accept: Boolean);
    procedure edtPesquisarFacilSistemasKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edtPesquisarFacilSistemasKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnSalvarPermissoesClick(Sender: TObject);
    procedure XDataClientSalvarPermissoesError(Error: TXDataClientError);
    procedure XDataClientSalvarPermissoesLoad(Response: TXDataClientResponse);
  private
  var
    FPermissoesAlteradas: TJSObject;

    function GetCds(pTabelaNome : string) : TXDataWebDataSet;
    procedure RegistrarAlteracao(pTabelaId, pCampoAlterado, pTabela : string; pNovoValor : Boolean);
  public
  var
    FUsuarioId : Integer;

    procedure CarregarCds(pCds : TXDataWebDataSet);
    procedure SetTituloModal(pTitulo : string);
    procedure ReiniciarCds;
    [async]
    procedure SalvarPermissoes; async;
  protected procedure LoadDFMValues; override; end;

var
  FramePermissoesUsuario: TFramePermissoesUsuario;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFramePermissoesUsuario }

procedure TFramePermissoesUsuario.btnFacilSistemasClick(Sender: TObject);
begin
  CarregarCds(cdsPermissoesFacilSistemas);
end;

procedure TFramePermissoesUsuario.btnMensagensClick(Sender: TObject);
begin
  CarregarCds(cdsPermissoesMensagens);
end;

procedure TFramePermissoesUsuario.btnSalvarPermissoesClick(Sender: TObject);
begin
  SalvarPermissoes;
end;

procedure TFramePermissoesUsuario.btnServiceClick(Sender: TObject);
begin
  CarregarCds(cdsPermissoesService);
end;

procedure TFramePermissoesUsuario.btnWhatsappClick(Sender: TObject);
begin
  CarregarCds(cdsPermissoesWhatsapp);
end;

procedure TFramePermissoesUsuario.CarregarCds(pCds: TXDataWebDataSet);
var
  lTabelaOrigem : Integer;
begin
  if pCds.Tag = 1 then
    Exit;

  TUtils.ChamarDivLoading;
  lTabelaOrigem := IndexStr(pCds.Name, ['cdsPermissoesFacilSistemas', 'cdsPermissoesService',
    'cdsPermissoesWhatsapp', 'cdsPermissoesMensagens']);


  pCds.Close;
  pCds.QueryString := '$filter=((usuario_id eq ' + FUsuarioId.ToString + ') and ' +
    '(tabela_sistema/tabela_origem eq '+lTabelaOrigem.ToString+')) &$expand=tabela_sistema' +
      '&$orderby=tabela_sistema/tabela';
  pCds.Load;
  pCds.Tag := 1;
end;

procedure TFramePermissoesUsuario.cdsPermissoesFacilSistemasAfterOpen(
  DataSet: TDataSet);
begin
  TUtils.OcultarDivLoading;
end;

procedure TFramePermissoesUsuario.cdsPermissoesFacilSistemasFilterRecord(
  DataSet: TDataSet; var Accept: Boolean);
var
  lCampo, lFiltro: string;
begin
  lCampo := LowerCase(DataSet.FieldByName('tabela_sistema.tabela').AsString);
  lFiltro := LowerCase(Trim(edtPesquisarFacilSistemas.Text));

  if lFiltro = '' then
    Accept := True
  else
    Accept := Pos(lFiltro, lCampo) > 0;
end;

procedure TFramePermissoesUsuario.cdsPermissoesServiceAfterOpen(
  DataSet: TDataSet);
begin
  TUtils.OcultarDivLoading;
  cdsPermissoesService.Refresh;
end;

procedure TFramePermissoesUsuario.cdsPermissoesServiceFilterRecord(
  DataSet: TDataSet; var Accept: Boolean);
var
  lCampo, lFiltro: string;
begin
  lCampo := LowerCase(DataSet.FieldByName('tabela_sistema.tabela').AsString);
  lFiltro := LowerCase(Trim(edtPesquisarService.Text));

  if lFiltro = '' then
    Accept := True
  else
    Accept := Pos(lFiltro, lCampo) > 0;
end;

procedure TFramePermissoesUsuario.cdsPermissoesWhatsappAfterOpen(
  DataSet: TDataSet);
begin
  TUtils.OcultarDivLoading;
end;

procedure TFramePermissoesUsuario.edtPesquisarFacilSistemasKeyDown(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsultaFacilSistemas.Enabled := False;

  if Key = 13 then
    cdsPermissoesFacilSistemas.Filtered := True;
end;

procedure TFramePermissoesUsuario.edtPesquisarFacilSistemasKeyUp(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsultaFacilSistemas.Interval := FTimerConsulta;
  tmrConsultaFacilSistemas.Enabled := True;
end;

procedure TFramePermissoesUsuario.edtPesquisarServiceKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaService.Enabled := False;

  if Key = 13 then
    cdsPermissoesService.Filtered := True;
end;

procedure TFramePermissoesUsuario.edtPesquisarServiceKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaService.Interval := FTimerConsulta;
  tmrConsultaService.Enabled := True;
end;

function TFramePermissoesUsuario.GetCds(pTabelaNome: string): TXDataWebDataSet;
begin
  case IndexStr(pTabelaNome, ['tblPermissoesService', 'tblPermissoesFacilSistemas',
    'tblPermissoesWhatsapp', 'tblPermissoesMensagens']) of
    0: Result := cdsPermissoesService;
    1: Result := cdsPermissoesFacilSistemas;
    2: Result := cdsPermissoesWhatsapp;
    3: Result := cdsPermissoesmensagens;
  end;
end;

procedure TFramePermissoesUsuario.SalvarPermissoes;
var
  lChave,
  lSubChave : string;
  lItem,
  lValores,
  lJsonEnvio : TJSObject;
  lArray : TJSArray;
begin
  lArray := TJSArray.new;

  for lChave in TJSObject.keys(FPermissoesAlteradas) do
  begin
    lItem := TJSObject(FPermissoesAlteradas.Properties[lChave]);

    if TJSJSON.stringify(lItem) = '{}' then
      Continue;

    lJsonEnvio := TJSObject.new;
    lJsonEnvio['tabela_id'] := lChave;

    for lSubChave in TJSObject.keys(lItem) do
    begin
      lValores := TJSObject(lItem.Properties[lSubChave]);
      lJsonEnvio[lSubChave] := Boolean(lValores['new']);
    end;

    lJsonEnvio['tabela'] := string(lValores['tabela']);
    lArray.push(lJsonEnvio);
  end;

  if lArray.flength = 0 then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma permissão alterada!')
  else
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
      'atualizar as permissões?')) then
    begin
      TUtils.ChamarDivLoading;
      XDataClientSalvarPermissoes.RawInvoke('IService.AtualizarPermissoesUsuario', [FUsuarioId.ToString, lArray]);
    end;
  end;
end;

procedure TFramePermissoesUsuario.SetTituloModal(pTitulo: string);
begin
  lblDescricaoPermissao.Caption := pTitulo;
  btnSalvarPermissoes.Enabled := TUtils.PossuiPermissao(cdsPermissoesService.EntitySetName.ToLower, TTipoPermissao.ALTERAR);
  btnFacilSistemas.Visible := TUtils.IsPerfilFacilSistemas(TUtils.FUsuario);
  btnFacilSistemas.Enabled := TUtils.IsPerfilFacilSistemas(TUtils.FUsuario);;

  FPermissoesAlteradas := TJSObject.New;
end;

procedure TFramePermissoesUsuario.TabelaClickCell(Sender: TObject; ACol,
  ARow: Integer);
var
  lTabela : TDBTableControl;
  lMarcar,
  lOldValue : Boolean;
  lCds : TXDataWebDataSet;
  lTipoPermissao : string;
  lPermitirOperacao : Boolean;
begin
  lTabela := TDBTableControl(Sender);

  if TUtils.PossuiPermissao(cdsPermissoesService.EntitySetName.ToLower, TTipoPermissao.ALTERAR) and
    (ARow = 0) and (lTabela.Columns[ACol].Title.ToLower <> 'tabela')  then
  begin
    lTipoPermissao := lTabela.Columns[ACol].Title.ToLower;
    lCds := GetCds(lTabela.Name);
    lMarcar := lTabela.Columns[ACol].Tag = 0;

    TUtils.ChamarDivLoading;
    lCds.DisableControls;
    lcds.First;

    try
      while not lCds.Eof do
      begin
        lPermitirOperacao := True;
        lOldValue := lCds.FieldByName(lTipoPermissao).AsBoolean;

        if (lOldValue <> lMarcar) then
        begin
          if (lTipoPermissao = 'excluir') and lMarcar then
          begin
            lPermitirOperacao := AnsiIndexStr(lCds.FieldByName('tabela_id').AsString,
              FIdsTabelasPermitemExclusao) >= 0;
          end;

          if lPermitirOperacao then
          begin
            lCds.Edit;
            lCds.FieldByName(lTipoPermissao).AsBoolean := lMarcar;
            lCds.Post;

            RegistrarAlteracao(lCds.FieldByName('tabela_id').AsString, lTipoPermissao,
              lCds.FieldByName('tabela_sistema.tabela').AsString, lMarcar);
          end;
        end;

        lCds.Next;
      end;
    finally
      lCds.EnableControls;
      TUtils.OcultarDivLoading;
    end;

    if lMarcar then
      lTabela.Columns[ACol].Tag := 1
    else
      lTabela.Columns[ACol].Tag := 0;
  end;
end;

procedure TFramePermissoesUsuario.TabelaGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId,
  RecordTabelaId : Integer;
  RecordCds : TXDataWebDataSet;

procedure CheckBoxButtonClick(Sender: TObject);
var
  lCheckBoxClicado: TCheckBox;
  lTipoPermissao : string;
begin
  lCheckBoxClicado := TCheckBox(Sender);

  if RecordCds.Locate('id', RecordId,[loCaseInsensitive,loPartialKey]) then
  begin
    RecordCds.Edit;
    case lCheckBoxClicado.Tag of
      0: lTipoPermissao := 'visualizar';
      1: lTipoPermissao := 'inserir';
      2: lTipoPermissao := 'alterar';
      3: lTipoPermissao := 'excluir';
    end;

    RecordCds.FieldByName(lTipoPermissao).AsBoolean := lCheckBoxClicado.Checked;
    RecordCds.Post;

    RegistrarAlteracao(RecordTabelaId.ToString, lTipoPermissao, RecordCds.FieldByName('tabela_sistema.tabela').AsString,
      RecordCds.FieldByName(lTipoPermissao).AsBoolean);
  end;
end;

var
  lCheckBox: TCheckBox;
  lTabela : TDBTableControl;
begin
  if ARow = 0 then
    Exit;

  lTabela := TDBTableControl(Sender);
  RecordCds := GetCds(lTabela.Name);

  if lTabela.Columns[ACol].Title.ToLower <> 'tabela' then
  begin
    RecordId := RecordCds.FieldByName('id').AsInteger;
    RecordTabelaId := RecordCds.FieldByName('tabela_id').AsInteger;

    lCheckBox := TCheckBox.Create(nil);
    lCheckBox.OnClick := @CheckBoxButtonClick;
    lCheckBox.ParentElement := AElement.element;
    lCheckBox.WidthStyle := TSizeStyle.ssAuto;
    lCheckBox.HeightStyle := TSizeStyle.ssAuto;
    lCheckBox.Checked := RecordCds.FieldByName(lTabela.Columns[ACol].Title.ToLower).AsBoolean;
    lCheckBox.ElementClassName := 'checkbox-table';

    case IndexStr(lTabela.Columns[ACol].Title, ['Visualizar', 'Inserir', 'Alterar', 'Excluir']) of
      3 :
      begin
        lCheckBox.Enabled := (AnsiIndexStr(RecordTabelaId.ToString, FIdsTabelasPermitemExclusao) >= 0) and
          TUtils.PossuiPermissao(RecordCds.EntitySetName.ToLower, TTipoPermissao.ALTERAR);
      end;
      else
        lCheckBox.Enabled := TUtils.PossuiPermissao(RecordCds.EntitySetName.ToLower, TTipoPermissao.ALTERAR);
    end;

    lCheckBox.Tag := IndexStr(lTabela.Columns[ACol].Title, ['Visualizar', 'Inserir',
      'Alterar', 'Excluir']);
    lCheckBox.ElementHandle.setAttribute('data-test', lTabela.Columns[ACol].Title.ToLower + 'Permissoes');
  end;
end;

procedure TFramePermissoesUsuario.TabelaGetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
var
  lTabela : TDBTableControl;
begin
  lTabela := TDBTableControl(Sender);

  if (ARow = 0) or (lTabela.Columns[ACol].Title.ToLower <> 'tabela') then
    AClassName := 'text-center';
end;

procedure TFramePermissoesUsuario.TabelaGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
var
  lTabela : TDBTableControl;
  lCursor,
  lToolip,
  lDataTest,
  lTabelaNome : string;
begin
  lTabela := TDBTableControl(Sender);
  lTabelaNome := lTabela.Name;
  lCursor := '';
  lToolip := '';

  if ARow = 0 then
  begin
    lDataTest := ' data-test="' + lTabela.Columns[ACol].Title.ToLower + 'Todos' + lTabelaNome.Replace('tbl', '') + '"';

    if TUtils.PossuiPermissao(cdsPermissoesService.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      lToolip := 'data-bs-toggle="tooltip" title="Marcar/Desmarcar Todos"';
      lCursor := 'cursor-pointer';
    end;

    case IndexStr(lTabela.Columns[ACol].Title, ['Visualizar', 'Inserir',
      'Alterar', 'Excluir']) of
      0: AValue := '<i class="fas fa-eye text-primary fa-lg '+lCursor+'" '+lToolip + lDataTest +'><i>';
      1: AValue := '<i class="fas fa-plus-square text-primary fa-lg '+lCursor+'" '+lToolip+ lDataTest +'><i>';
      2: AValue := '<i class="fas fa-edit text-primary fa-lg '+lCursor+'" '+lToolip+ lDataTest +'><i>';
      3: AValue := '<i class="fas fa-trash-alt text-primary fa-lg '+lCursor+'" '+lToolip+ lDataTest +'><i>';
    end;
  end
  else if lTabela.Columns[ACol].Title.ToLower = 'tabela' then
  begin
    AValue := AValue.Replace('_', ' ');
    AValue := AnsiProperCase(AValue, [' ']);
  end;
end;

procedure TFramePermissoesUsuario.tmrConsultaFacilSistemasTimer(
  Sender: TObject);
begin
  cdsPermissoesFacilSistemas.Filtered := True;

  tmrConsultaFacilSistemas.Enabled := False;
  tmrConsultaFacilSistemas.Interval := FTimerConsulta;
end;

procedure TFramePermissoesUsuario.tmrConsultaServiceTimer(Sender: TObject);
begin
  cdsPermissoesService.Filtered := True;

  tmrConsultaService.Enabled := False;
  tmrConsultaService.Interval := FTimerConsulta;
end;

procedure TFramePermissoesUsuario.XDataClientSalvarPermissoesError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFramePermissoesUsuario.XDataClientSalvarPermissoesLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Permissões atualizadas com sucesso!');
  FPermissoesAlteradas := TJSObject.New;
end;

procedure TFramePermissoesUsuario.cdsPermissoesMensagensAfterOpen(DataSet: TDataSet);
begin
  TUtils.OcultarDivLoading;
end;

procedure TFramePermissoesUsuario.RegistrarAlteracao(pTabelaId, pCampoAlterado, pTabela: string;
  pNovoValor: Boolean);
var
  lRegistro,
  lCampoObj: TJSObject;
begin
  if not Assigned(FPermissoesAlteradas[pTabelaId]) then
    FPermissoesAlteradas[pTabelaId] := TJSObject.New;

  lRegistro := TJSObject(FPermissoesAlteradas[pTabelaId]);

   // Se o campo ainda não existe, cria com old=new (primeira alteração)
  if not lRegistro.hasOwnProperty(pCampoAlterado) then
  begin
    lCampoObj := TJSObject.New;
    lCampoObj['old'] := not pNovoValor;
    lCampoObj['new'] := pNovoValor;
    lCampoObj['tabela'] := pTabela;
    lRegistro[pCampoAlterado] := lCampoObj;
    Exit;
  end;

   // Se o campo já existia, pega o objeto
  lCampoObj := TJSObject(lRegistro[pCampoAlterado]);

  // Atualiza o "new" value
  lCampoObj['new'] := pNovoValor;

  // Se o new == old, remove o campo (voltou ao estado original)
  if lCampoObj['old'] = lCampoObj['new'] then
    asm delete lRegistro[pCampoAlterado]; end;
end;

procedure TFramePermissoesUsuario.ReiniciarCds;
begin
  cdsPermissoesService.Tag := 0;
  cdsPermissoesFacilSistemas.Tag := 0;
  cdsPermissoesWhatsapp.Tag := 0;
  cdsPermissoesMensagens.Tag := 0;

  tblPermissoesService.Columns[1].Tag := 0;
  tblPermissoesService.Columns[2].Tag := 0;
  tblPermissoesService.Columns[3].Tag := 0;
  tblPermissoesService.Columns[4].Tag := 0;

  tblPermissoesWhatsapp.Columns[1].Tag := 0;
  tblPermissoesWhatsapp.Columns[2].Tag := 0;
  tblPermissoesWhatsapp.Columns[3].Tag := 0;
  tblPermissoesWhatsapp.Columns[4].Tag := 0;

  tblPermissoesMensagens.Columns[1].Tag := 0;
  tblPermissoesMensagens.Columns[2].Tag := 0;
  tblPermissoesMensagens.Columns[3].Tag := 0;
  tblPermissoesMensagens.Columns[4].Tag := 0;

  tblPermissoesFacilSistemas.Columns[1].Tag := 0;
  tblPermissoesFacilSistemas.Columns[2].Tag := 0;
  tblPermissoesFacilSistemas.Columns[3].Tag := 0;
  tblPermissoesFacilSistemas.Columns[4].Tag := 0;

  edtPesquisarService.Text := EmptyStr;
  edtPesquisarFacilSistemas.Text := EmptyStr;
  cdsPermissoesService.Filtered := False;
  cdsPermissoesFacilSistemas.Filtered := False;
end;

procedure TFramePermissoesUsuario.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblDescricaoPermissao := TLabel.Create('modal_permissoes_Label');
  pnlPermissoesFacil := TPanel.Create(Self);
  tblPermissoesFacilSistemas := TDBTableControl.Create('tblPermissoesFacilSistemas');
  pnlPermissoesService := TPanel.Create(Self);
  tblPermissoesService := TDBTableControl.Create('tblPermissoesService');
  btnSalvarPermissoes := TButton.Create('btnSalvarPermissoes');
  edtPesquisarFacilSistemas := TEdit.Create('edtPesquisarFacilSistemas');
  edtPesquisarService := TEdit.Create('edtPesquisarService');
  btnService := TButton.Create('line-service-tab');
  btnFacilSistemas := TButton.Create('line-facil_sistemas-tab');
  pnlWhatsapp := TPanel.Create(Self);
  tblPermissoesWhatsapp := TDBTableControl.Create('tblPermissoesWhatsapp');
  btnWhatsapp := TButton.Create('line-whatsapp-tab');
  pnlMensagens := TPanel.Create(Self);
  tblPermissoesMensagens := TDBTableControl.Create('tblPermissoesMensagens');
  btnMensagens := TButton.Create('line-mensagens-tab');
  cdsPermissoesService := TXDataWebDataSet.Create(Self);
  cdsPermissoesServiceid := TIntegerField.Create(Self);
  cdsPermissoesServicevisualizar := TBooleanField.Create(Self);
  cdsPermissoesServiceinserir := TBooleanField.Create(Self);
  cdsPermissoesServicealterar := TBooleanField.Create(Self);
  cdsPermissoesServiceexcluir := TBooleanField.Create(Self);
  cdsPermissoesServicetabela_sistematabela := TStringField.Create(Self);
  cdsPermissoesServiceusuario_id := TIntegerField.Create(Self);
  cdsPermissoesServicetabela_sistematabela_origem := TIntegerField.Create(Self);
  cdsPermissoesServicetabela_id := TIntegerField.Create(Self);
  dtsPermissoesService := TDataSource.Create(Self);
  cdsPermissoesFacilSistemas := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  BooleanField2 := TBooleanField.Create(Self);
  BooleanField3 := TBooleanField.Create(Self);
  BooleanField4 := TBooleanField.Create(Self);
  StringField1 := TStringField.Create(Self);
  IntegerField2 := TIntegerField.Create(Self);
  cdsPermissoesFacilSistemastabela_sistematabela_origem := TIntegerField.Create(Self);
  cdsPermissoesFacilSistemastabela_id := TIntegerField.Create(Self);
  dtsPermissoesFacilSistemas := TDataSource.Create(Self);
  cdsPermissoesWhatsapp := TXDataWebDataSet.Create(Self);
  IntegerField3 := TIntegerField.Create(Self);
  BooleanField5 := TBooleanField.Create(Self);
  BooleanField6 := TBooleanField.Create(Self);
  BooleanField7 := TBooleanField.Create(Self);
  BooleanField8 := TBooleanField.Create(Self);
  StringField2 := TStringField.Create(Self);
  IntegerField4 := TIntegerField.Create(Self);
  IntegerField5 := TIntegerField.Create(Self);
  cdsPermissoesWhatsapptabela_id := TIntegerField.Create(Self);
  dtsPermissoesWhatsapp := TDataSource.Create(Self);
  cdsPermissoesMensagens := TXDataWebDataSet.Create(Self);
  IntegerField6 := TIntegerField.Create(Self);
  BooleanField9 := TBooleanField.Create(Self);
  BooleanField10 := TBooleanField.Create(Self);
  BooleanField11 := TBooleanField.Create(Self);
  BooleanField12 := TBooleanField.Create(Self);
  StringField3 := TStringField.Create(Self);
  IntegerField7 := TIntegerField.Create(Self);
  IntegerField8 := TIntegerField.Create(Self);
  cdsPermissoesMensagenstabela_id := TIntegerField.Create(Self);
  dtsPermissoesMensagens := TDataSource.Create(Self);
  tmrConsultaService := TTimer.Create(Self);
  tmrConsultaFacilSistemas := TTimer.Create(Self);
  XDataClientSalvarPermissoes := TXDataWebClient.Create(Self);

  lblDescricaoPermissao.BeforeLoadDFMValues;
  pnlPermissoesFacil.BeforeLoadDFMValues;
  tblPermissoesFacilSistemas.BeforeLoadDFMValues;
  pnlPermissoesService.BeforeLoadDFMValues;
  tblPermissoesService.BeforeLoadDFMValues;
  btnSalvarPermissoes.BeforeLoadDFMValues;
  edtPesquisarFacilSistemas.BeforeLoadDFMValues;
  edtPesquisarService.BeforeLoadDFMValues;
  btnService.BeforeLoadDFMValues;
  btnFacilSistemas.BeforeLoadDFMValues;
  pnlWhatsapp.BeforeLoadDFMValues;
  tblPermissoesWhatsapp.BeforeLoadDFMValues;
  btnWhatsapp.BeforeLoadDFMValues;
  pnlMensagens.BeforeLoadDFMValues;
  tblPermissoesMensagens.BeforeLoadDFMValues;
  btnMensagens.BeforeLoadDFMValues;
  cdsPermissoesService.BeforeLoadDFMValues;
  cdsPermissoesServiceid.BeforeLoadDFMValues;
  cdsPermissoesServicevisualizar.BeforeLoadDFMValues;
  cdsPermissoesServiceinserir.BeforeLoadDFMValues;
  cdsPermissoesServicealterar.BeforeLoadDFMValues;
  cdsPermissoesServiceexcluir.BeforeLoadDFMValues;
  cdsPermissoesServicetabela_sistematabela.BeforeLoadDFMValues;
  cdsPermissoesServiceusuario_id.BeforeLoadDFMValues;
  cdsPermissoesServicetabela_sistematabela_origem.BeforeLoadDFMValues;
  cdsPermissoesServicetabela_id.BeforeLoadDFMValues;
  dtsPermissoesService.BeforeLoadDFMValues;
  cdsPermissoesFacilSistemas.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  BooleanField2.BeforeLoadDFMValues;
  BooleanField3.BeforeLoadDFMValues;
  BooleanField4.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  IntegerField2.BeforeLoadDFMValues;
  cdsPermissoesFacilSistemastabela_sistematabela_origem.BeforeLoadDFMValues;
  cdsPermissoesFacilSistemastabela_id.BeforeLoadDFMValues;
  dtsPermissoesFacilSistemas.BeforeLoadDFMValues;
  cdsPermissoesWhatsapp.BeforeLoadDFMValues;
  IntegerField3.BeforeLoadDFMValues;
  BooleanField5.BeforeLoadDFMValues;
  BooleanField6.BeforeLoadDFMValues;
  BooleanField7.BeforeLoadDFMValues;
  BooleanField8.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  IntegerField4.BeforeLoadDFMValues;
  IntegerField5.BeforeLoadDFMValues;
  cdsPermissoesWhatsapptabela_id.BeforeLoadDFMValues;
  dtsPermissoesWhatsapp.BeforeLoadDFMValues;
  cdsPermissoesMensagens.BeforeLoadDFMValues;
  IntegerField6.BeforeLoadDFMValues;
  BooleanField9.BeforeLoadDFMValues;
  BooleanField10.BeforeLoadDFMValues;
  BooleanField11.BeforeLoadDFMValues;
  BooleanField12.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  IntegerField7.BeforeLoadDFMValues;
  IntegerField8.BeforeLoadDFMValues;
  cdsPermissoesMensagenstabela_id.BeforeLoadDFMValues;
  dtsPermissoesMensagens.BeforeLoadDFMValues;
  tmrConsultaService.BeforeLoadDFMValues;
  tmrConsultaFacilSistemas.BeforeLoadDFMValues;
  XDataClientSalvarPermissoes.BeforeLoadDFMValues;
  try
    Name := 'FramePermissoesUsuario';
    Left := 0;
    Top := 0;
    Width := 768;
    Height := 388;
    TabOrder := 0;
    lblDescricaoPermissao.SetParentComponent(Self);
    lblDescricaoPermissao.Name := 'lblDescricaoPermissao';
    lblDescricaoPermissao.Left := 123;
    lblDescricaoPermissao.Top := 327;
    lblDescricaoPermissao.Width := 54;
    lblDescricaoPermissao.Height := 15;
    lblDescricaoPermissao.Caption := 'Permiss'#227'o';
    lblDescricaoPermissao.Color := clBtnFace;
    lblDescricaoPermissao.HeightPercent := 100.000000000000000000;
    lblDescricaoPermissao.WidthPercent := 100.000000000000000000;
    pnlPermissoesFacil.SetParentComponent(Self);
    pnlPermissoesFacil.Name := 'pnlPermissoesFacil';
    pnlPermissoesFacil.Left := 198;
    pnlPermissoesFacil.Top := 2;
    pnlPermissoesFacil.Width := 174;
    pnlPermissoesFacil.Height := 17;
    pnlPermissoesFacil.Caption := 'Espa'#231'o Permiss'#245'es F'#225'cil';
    pnlPermissoesFacil.ChildOrder := 23;
    pnlPermissoesFacil.Color := clInfoText;
    pnlPermissoesFacil.Font.Charset := DEFAULT_CHARSET;
    pnlPermissoesFacil.Font.Color := clWhite;
    pnlPermissoesFacil.Font.Height := -11;
    pnlPermissoesFacil.Font.Name := 'Tahoma';
    pnlPermissoesFacil.Font.Style := [fsBold];
    pnlPermissoesFacil.ParentFont := False;
    pnlPermissoesFacil.TabOrder := 0;
    pnlPermissoesFacil.Visible := False;
    tblPermissoesFacilSistemas.SetParentComponent(Self);
    tblPermissoesFacilSistemas.Name := 'tblPermissoesFacilSistemas';
    tblPermissoesFacilSistemas.Left := 198;
    tblPermissoesFacilSistemas.Top := 21;
    tblPermissoesFacilSistemas.Width := 174;
    tblPermissoesFacilSistemas.Height := 200;
    tblPermissoesFacilSistemas.ElementClassName := 'table-responsive';
    tblPermissoesFacilSistemas.BorderColor := clSilver;
    tblPermissoesFacilSistemas.ChildOrder := 19;
    tblPermissoesFacilSistemas.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblPermissoesFacilSistemas, Self, 'OnClickCell', 'TabelaClickCell');
    SetEvent(tblPermissoesFacilSistemas, Self, 'OnGetCellData', 'TabelaGetCellData');
    SetEvent(tblPermissoesFacilSistemas, Self, 'OnGetCellChildren', 'TabelaGetCellChildren');
    SetEvent(tblPermissoesFacilSistemas, Self, 'OnGetCellClass', 'TabelaGetCellClass');
    tblPermissoesFacilSistemas.Columns.Clear;
    with tblPermissoesFacilSistemas.Columns.Add do
    begin
      DataField := 'tabela_sistema.tabela';
      Title := 'Tabela';
    end;
    with tblPermissoesFacilSistemas.Columns.Add do
    begin
      Title := 'Visualizar';
    end;
    with tblPermissoesFacilSistemas.Columns.Add do
    begin
      Title := 'Inserir';
    end;
    with tblPermissoesFacilSistemas.Columns.Add do
    begin
      Title := 'Alterar';
    end;
    with tblPermissoesFacilSistemas.Columns.Add do
    begin
      Title := 'Excluir';
    end;
    tblPermissoesFacilSistemas.DataSource := dtsPermissoesFacilSistemas;
    pnlPermissoesService.SetParentComponent(Self);
    pnlPermissoesService.Name := 'pnlPermissoesService';
    pnlPermissoesService.Left := 3;
    pnlPermissoesService.Top := 3;
    pnlPermissoesService.Width := 174;
    pnlPermissoesService.Height := 17;
    pnlPermissoesService.Caption := 'Espa'#231'o Permiss'#245'es Service';
    pnlPermissoesService.ChildOrder := 23;
    pnlPermissoesService.Color := clInfoText;
    pnlPermissoesService.Font.Charset := DEFAULT_CHARSET;
    pnlPermissoesService.Font.Color := clWhite;
    pnlPermissoesService.Font.Height := -11;
    pnlPermissoesService.Font.Name := 'Tahoma';
    pnlPermissoesService.Font.Style := [fsBold];
    pnlPermissoesService.ParentFont := False;
    pnlPermissoesService.TabOrder := 2;
    pnlPermissoesService.Visible := False;
    tblPermissoesService.SetParentComponent(Self);
    tblPermissoesService.Name := 'tblPermissoesService';
    tblPermissoesService.Left := 3;
    tblPermissoesService.Top := 21;
    tblPermissoesService.Width := 174;
    tblPermissoesService.Height := 200;
    tblPermissoesService.ElementClassName := 'table-responsive';
    tblPermissoesService.BorderColor := clSilver;
    tblPermissoesService.ChildOrder := 19;
    tblPermissoesService.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblPermissoesService, Self, 'OnClickCell', 'TabelaClickCell');
    SetEvent(tblPermissoesService, Self, 'OnGetCellData', 'TabelaGetCellData');
    SetEvent(tblPermissoesService, Self, 'OnGetCellChildren', 'TabelaGetCellChildren');
    SetEvent(tblPermissoesService, Self, 'OnGetCellClass', 'TabelaGetCellClass');
    tblPermissoesService.Columns.Clear;
    with tblPermissoesService.Columns.Add do
    begin
      DataField := 'tabela_sistema.tabela';
      Title := 'Tabela';
    end;
    with tblPermissoesService.Columns.Add do
    begin
      Title := 'Visualizar';
    end;
    with tblPermissoesService.Columns.Add do
    begin
      Title := 'Inserir';
    end;
    with tblPermissoesService.Columns.Add do
    begin
      Title := 'Alterar';
    end;
    with tblPermissoesService.Columns.Add do
    begin
      Title := 'Excluir';
    end;
    tblPermissoesService.DataSource := dtsPermissoesService;
    btnSalvarPermissoes.SetParentComponent(Self);
    btnSalvarPermissoes.Name := 'btnSalvarPermissoes';
    btnSalvarPermissoes.Left := 3;
    btnSalvarPermissoes.Top := 323;
    btnSalvarPermissoes.Width := 96;
    btnSalvarPermissoes.Height := 25;
    btnSalvarPermissoes.Caption := 'Salvar';
    btnSalvarPermissoes.ChildOrder := 8;
    btnSalvarPermissoes.HeightPercent := 100.000000000000000000;
    btnSalvarPermissoes.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarPermissoes, Self, 'OnClick', 'btnSalvarPermissoesClick');
    edtPesquisarFacilSistemas.SetParentComponent(Self);
    edtPesquisarFacilSistemas.Name := 'edtPesquisarFacilSistemas';
    edtPesquisarFacilSistemas.Left := 198;
    edtPesquisarFacilSistemas.Top := 227;
    edtPesquisarFacilSistemas.Width := 96;
    edtPesquisarFacilSistemas.Height := 22;
    edtPesquisarFacilSistemas.ChildOrder := 10;
    edtPesquisarFacilSistemas.HeightPercent := 100.000000000000000000;
    edtPesquisarFacilSistemas.WidthPercent := 100.000000000000000000;
    SetEvent(edtPesquisarFacilSistemas, Self, 'OnKeyDown', 'edtPesquisarFacilSistemasKeyDown');
    SetEvent(edtPesquisarFacilSistemas, Self, 'OnKeyUp', 'edtPesquisarFacilSistemasKeyUp');
    edtPesquisarService.SetParentComponent(Self);
    edtPesquisarService.Name := 'edtPesquisarService';
    edtPesquisarService.Left := 3;
    edtPesquisarService.Top := 227;
    edtPesquisarService.Width := 96;
    edtPesquisarService.Height := 22;
    edtPesquisarService.ChildOrder := 10;
    edtPesquisarService.HeightPercent := 100.000000000000000000;
    edtPesquisarService.WidthPercent := 100.000000000000000000;
    SetEvent(edtPesquisarService, Self, 'OnKeyDown', 'edtPesquisarServiceKeyDown');
    SetEvent(edtPesquisarService, Self, 'OnKeyUp', 'edtPesquisarServiceKeyUp');
    btnService.SetParentComponent(Self);
    btnService.Name := 'btnService';
    btnService.Left := 3;
    btnService.Top := 355;
    btnService.Width := 96;
    btnService.Height := 25;
    btnService.Caption := 'Service';
    btnService.ChildOrder := 14;
    btnService.HeightPercent := 100.000000000000000000;
    btnService.WidthPercent := 100.000000000000000000;
    SetEvent(btnService, Self, 'OnClick', 'btnServiceClick');
    btnFacilSistemas.SetParentComponent(Self);
    btnFacilSistemas.Name := 'btnFacilSistemas';
    btnFacilSistemas.Left := 105;
    btnFacilSistemas.Top := 355;
    btnFacilSistemas.Width := 96;
    btnFacilSistemas.Height := 25;
    btnFacilSistemas.Caption := 'F'#225'cil Sistemas';
    btnFacilSistemas.ChildOrder := 14;
    btnFacilSistemas.HeightPercent := 100.000000000000000000;
    btnFacilSistemas.WidthPercent := 100.000000000000000000;
    SetEvent(btnFacilSistemas, Self, 'OnClick', 'btnFacilSistemasClick');
    pnlWhatsapp.SetParentComponent(Self);
    pnlWhatsapp.Name := 'pnlWhatsapp';
    pnlWhatsapp.Left := 390;
    pnlWhatsapp.Top := 2;
    pnlWhatsapp.Width := 174;
    pnlWhatsapp.Height := 17;
    pnlWhatsapp.Caption := 'Espa'#231'o Permiss'#245'es Whatsapp';
    pnlWhatsapp.ChildOrder := 23;
    pnlWhatsapp.Color := clInfoText;
    pnlWhatsapp.Font.Charset := DEFAULT_CHARSET;
    pnlWhatsapp.Font.Color := clWhite;
    pnlWhatsapp.Font.Height := -11;
    pnlWhatsapp.Font.Name := 'Tahoma';
    pnlWhatsapp.Font.Style := [fsBold];
    pnlWhatsapp.ParentFont := False;
    pnlWhatsapp.TabOrder := 9;
    pnlWhatsapp.Visible := False;
    tblPermissoesWhatsapp.SetParentComponent(Self);
    tblPermissoesWhatsapp.Name := 'tblPermissoesWhatsapp';
    tblPermissoesWhatsapp.Left := 390;
    tblPermissoesWhatsapp.Top := 21;
    tblPermissoesWhatsapp.Width := 174;
    tblPermissoesWhatsapp.Height := 200;
    tblPermissoesWhatsapp.ElementClassName := 'table-responsive';
    tblPermissoesWhatsapp.BorderColor := clSilver;
    tblPermissoesWhatsapp.ChildOrder := 19;
    tblPermissoesWhatsapp.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblPermissoesWhatsapp, Self, 'OnClickCell', 'TabelaClickCell');
    SetEvent(tblPermissoesWhatsapp, Self, 'OnGetCellData', 'TabelaGetCellData');
    SetEvent(tblPermissoesWhatsapp, Self, 'OnGetCellChildren', 'TabelaGetCellChildren');
    SetEvent(tblPermissoesWhatsapp, Self, 'OnGetCellClass', 'TabelaGetCellClass');
    tblPermissoesWhatsapp.Columns.Clear;
    with tblPermissoesWhatsapp.Columns.Add do
    begin
      DataField := 'tabela_sistema.tabela';
      Title := 'Tabela';
    end;
    with tblPermissoesWhatsapp.Columns.Add do
    begin
      Title := 'Visualizar';
    end;
    with tblPermissoesWhatsapp.Columns.Add do
    begin
      Title := 'Inserir';
    end;
    with tblPermissoesWhatsapp.Columns.Add do
    begin
      Title := 'Alterar';
    end;
    with tblPermissoesWhatsapp.Columns.Add do
    begin
      Title := 'Excluir';
    end;
    tblPermissoesWhatsapp.DataSource := dtsPermissoesWhatsapp;
    btnWhatsapp.SetParentComponent(Self);
    btnWhatsapp.Name := 'btnWhatsapp';
    btnWhatsapp.Left := 217;
    btnWhatsapp.Top := 355;
    btnWhatsapp.Width := 96;
    btnWhatsapp.Height := 25;
    btnWhatsapp.Caption := 'Whatsapp';
    btnWhatsapp.ChildOrder := 14;
    btnWhatsapp.HeightPercent := 100.000000000000000000;
    btnWhatsapp.WidthPercent := 100.000000000000000000;
    SetEvent(btnWhatsapp, Self, 'OnClick', 'btnWhatsappClick');
    pnlMensagens.SetParentComponent(Self);
    pnlMensagens.Name := 'pnlMensagens';
    pnlMensagens.Left := 582;
    pnlMensagens.Top := 2;
    pnlMensagens.Width := 174;
    pnlMensagens.Height := 17;
    pnlMensagens.Caption := 'Espa'#231'o Permiss'#245'es Mensagens';
    pnlMensagens.ChildOrder := 23;
    pnlMensagens.Color := clInfoText;
    pnlMensagens.Font.Charset := DEFAULT_CHARSET;
    pnlMensagens.Font.Color := clWhite;
    pnlMensagens.Font.Height := -11;
    pnlMensagens.Font.Name := 'Tahoma';
    pnlMensagens.Font.Style := [fsBold];
    pnlMensagens.ParentFont := False;
    pnlMensagens.TabOrder := 12;
    pnlMensagens.Visible := False;
    tblPermissoesMensagens.SetParentComponent(Self);
    tblPermissoesMensagens.Name := 'tblPermissoesMensagens';
    tblPermissoesMensagens.Left := 582;
    tblPermissoesMensagens.Top := 21;
    tblPermissoesMensagens.Width := 174;
    tblPermissoesMensagens.Height := 200;
    tblPermissoesMensagens.ElementClassName := 'table-responsive';
    tblPermissoesMensagens.BorderColor := clSilver;
    tblPermissoesMensagens.ChildOrder := 19;
    tblPermissoesMensagens.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblPermissoesMensagens, Self, 'OnClickCell', 'TabelaClickCell');
    SetEvent(tblPermissoesMensagens, Self, 'OnGetCellData', 'TabelaGetCellData');
    SetEvent(tblPermissoesMensagens, Self, 'OnGetCellChildren', 'TabelaGetCellChildren');
    SetEvent(tblPermissoesMensagens, Self, 'OnGetCellClass', 'TabelaGetCellClass');
    tblPermissoesMensagens.Columns.Clear;
    with tblPermissoesMensagens.Columns.Add do
    begin
      DataField := 'tabela_sistema.tabela';
      Title := 'Tabela';
    end;
    with tblPermissoesMensagens.Columns.Add do
    begin
      Title := 'Visualizar';
    end;
    with tblPermissoesMensagens.Columns.Add do
    begin
      Title := 'Inserir';
    end;
    with tblPermissoesMensagens.Columns.Add do
    begin
      Title := 'Alterar';
    end;
    with tblPermissoesMensagens.Columns.Add do
    begin
      Title := 'Excluir';
    end;
    tblPermissoesMensagens.DataSource := dtsPermissoesMensagens;
    btnMensagens.SetParentComponent(Self);
    btnMensagens.Name := 'btnMensagens';
    btnMensagens.Left := 319;
    btnMensagens.Top := 355;
    btnMensagens.Width := 96;
    btnMensagens.Height := 25;
    btnMensagens.Caption := 'Mensagens';
    btnMensagens.ChildOrder := 14;
    btnMensagens.HeightPercent := 100.000000000000000000;
    btnMensagens.WidthPercent := 100.000000000000000000;
    SetEvent(btnMensagens, Self, 'OnClick', 'btnMensagensClick');
    cdsPermissoesService.SetParentComponent(Self);
    cdsPermissoesService.Name := 'cdsPermissoesService';
    cdsPermissoesService.AfterOpen := cdsPermissoesServiceAfterOpen;
    SetEvent(cdsPermissoesService, Self, 'OnFilterRecord', 'cdsPermissoesServiceFilterRecord');
    cdsPermissoesService.EntitySetName := 'Permissoes_Usuario';
    cdsPermissoesService.Connection := DMConnection.ApiConnection;
    cdsPermissoesService.QueryTop := 500;
    cdsPermissoesService.Left := 24;
    cdsPermissoesService.Top := 256;
    cdsPermissoesServiceid.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServiceid.Name := 'cdsPermissoesServiceid';
    cdsPermissoesServiceid.FieldName := 'id';
    cdsPermissoesServiceid.Required := True;
    cdsPermissoesServicevisualizar.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServicevisualizar.Name := 'cdsPermissoesServicevisualizar';
    cdsPermissoesServicevisualizar.FieldName := 'visualizar';
    cdsPermissoesServicevisualizar.Required := True;
    cdsPermissoesServiceinserir.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServiceinserir.Name := 'cdsPermissoesServiceinserir';
    cdsPermissoesServiceinserir.FieldName := 'inserir';
    cdsPermissoesServiceinserir.Required := True;
    cdsPermissoesServicealterar.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServicealterar.Name := 'cdsPermissoesServicealterar';
    cdsPermissoesServicealterar.FieldName := 'alterar';
    cdsPermissoesServicealterar.Required := True;
    cdsPermissoesServiceexcluir.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServiceexcluir.Name := 'cdsPermissoesServiceexcluir';
    cdsPermissoesServiceexcluir.FieldName := 'excluir';
    cdsPermissoesServiceexcluir.Required := True;
    cdsPermissoesServicetabela_sistematabela.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServicetabela_sistematabela.Name := 'cdsPermissoesServicetabela_sistematabela';
    cdsPermissoesServicetabela_sistematabela.FieldName := 'tabela_sistema.tabela';
    cdsPermissoesServiceusuario_id.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServiceusuario_id.Name := 'cdsPermissoesServiceusuario_id';
    cdsPermissoesServiceusuario_id.FieldName := 'usuario_id';
    cdsPermissoesServiceusuario_id.Required := True;
    cdsPermissoesServicetabela_sistematabela_origem.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServicetabela_sistematabela_origem.Name := 'cdsPermissoesServicetabela_sistematabela_origem';
    cdsPermissoesServicetabela_sistematabela_origem.FieldName := 'tabela_sistema.tabela_origem';
    cdsPermissoesServicetabela_id.SetParentComponent(cdsPermissoesService);
    cdsPermissoesServicetabela_id.Name := 'cdsPermissoesServicetabela_id';
    cdsPermissoesServicetabela_id.FieldName := 'tabela_id';
    cdsPermissoesServicetabela_id.Required := True;
    dtsPermissoesService.SetParentComponent(Self);
    dtsPermissoesService.Name := 'dtsPermissoesService';
    dtsPermissoesService.DataSet := cdsPermissoesService;
    dtsPermissoesService.Left := 104;
    dtsPermissoesService.Top := 256;
    cdsPermissoesFacilSistemas.SetParentComponent(Self);
    cdsPermissoesFacilSistemas.Name := 'cdsPermissoesFacilSistemas';
    cdsPermissoesFacilSistemas.AfterOpen := cdsPermissoesFacilSistemasAfterOpen;
    SetEvent(cdsPermissoesFacilSistemas, Self, 'OnFilterRecord', 'cdsPermissoesFacilSistemasFilterRecord');
    cdsPermissoesFacilSistemas.EntitySetName := 'Permissoes_Usuario';
    cdsPermissoesFacilSistemas.Connection := DMConnection.ApiConnection;
    cdsPermissoesFacilSistemas.QueryTop := 500;
    cdsPermissoesFacilSistemas.Left := 216;
    cdsPermissoesFacilSistemas.Top := 264;
    IntegerField1.SetParentComponent(cdsPermissoesFacilSistemas);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'id';
    IntegerField1.Required := True;
    BooleanField1.SetParentComponent(cdsPermissoesFacilSistemas);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'visualizar';
    BooleanField1.Required := True;
    BooleanField2.SetParentComponent(cdsPermissoesFacilSistemas);
    BooleanField2.Name := 'BooleanField2';
    BooleanField2.FieldName := 'inserir';
    BooleanField2.Required := True;
    BooleanField3.SetParentComponent(cdsPermissoesFacilSistemas);
    BooleanField3.Name := 'BooleanField3';
    BooleanField3.FieldName := 'alterar';
    BooleanField3.Required := True;
    BooleanField4.SetParentComponent(cdsPermissoesFacilSistemas);
    BooleanField4.Name := 'BooleanField4';
    BooleanField4.FieldName := 'excluir';
    BooleanField4.Required := True;
    StringField1.SetParentComponent(cdsPermissoesFacilSistemas);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'tabela_sistema.tabela';
    IntegerField2.SetParentComponent(cdsPermissoesFacilSistemas);
    IntegerField2.Name := 'IntegerField2';
    IntegerField2.FieldName := 'usuario_id';
    IntegerField2.Required := True;
    cdsPermissoesFacilSistemastabela_sistematabela_origem.SetParentComponent(cdsPermissoesFacilSistemas);
    cdsPermissoesFacilSistemastabela_sistematabela_origem.Name := 'cdsPermissoesFacilSistemastabela_sistematabela_origem';
    cdsPermissoesFacilSistemastabela_sistematabela_origem.FieldName := 'tabela_sistema.tabela_origem';
    cdsPermissoesFacilSistemastabela_id.SetParentComponent(cdsPermissoesFacilSistemas);
    cdsPermissoesFacilSistemastabela_id.Name := 'cdsPermissoesFacilSistemastabela_id';
    cdsPermissoesFacilSistemastabela_id.FieldName := 'tabela_id';
    cdsPermissoesFacilSistemastabela_id.Required := True;
    dtsPermissoesFacilSistemas.SetParentComponent(Self);
    dtsPermissoesFacilSistemas.Name := 'dtsPermissoesFacilSistemas';
    dtsPermissoesFacilSistemas.DataSet := cdsPermissoesFacilSistemas;
    dtsPermissoesFacilSistemas.Left := 280;
    dtsPermissoesFacilSistemas.Top := 264;
    cdsPermissoesWhatsapp.SetParentComponent(Self);
    cdsPermissoesWhatsapp.Name := 'cdsPermissoesWhatsapp';
    cdsPermissoesWhatsapp.AfterOpen := cdsPermissoesWhatsappAfterOpen;
    cdsPermissoesWhatsapp.EntitySetName := 'Permissoes_Usuario';
    cdsPermissoesWhatsapp.Connection := DMConnection.ApiConnection;
    cdsPermissoesWhatsapp.QueryTop := 500;
    cdsPermissoesWhatsapp.Left := 408;
    cdsPermissoesWhatsapp.Top := 264;
    IntegerField3.SetParentComponent(cdsPermissoesWhatsapp);
    IntegerField3.Name := 'IntegerField3';
    IntegerField3.FieldName := 'id';
    IntegerField3.Required := True;
    BooleanField5.SetParentComponent(cdsPermissoesWhatsapp);
    BooleanField5.Name := 'BooleanField5';
    BooleanField5.FieldName := 'visualizar';
    BooleanField5.Required := True;
    BooleanField6.SetParentComponent(cdsPermissoesWhatsapp);
    BooleanField6.Name := 'BooleanField6';
    BooleanField6.FieldName := 'inserir';
    BooleanField6.Required := True;
    BooleanField7.SetParentComponent(cdsPermissoesWhatsapp);
    BooleanField7.Name := 'BooleanField7';
    BooleanField7.FieldName := 'alterar';
    BooleanField7.Required := True;
    BooleanField8.SetParentComponent(cdsPermissoesWhatsapp);
    BooleanField8.Name := 'BooleanField8';
    BooleanField8.FieldName := 'excluir';
    BooleanField8.Required := True;
    StringField2.SetParentComponent(cdsPermissoesWhatsapp);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'tabela_sistema.tabela';
    IntegerField4.SetParentComponent(cdsPermissoesWhatsapp);
    IntegerField4.Name := 'IntegerField4';
    IntegerField4.FieldName := 'usuario_id';
    IntegerField4.Required := True;
    IntegerField5.SetParentComponent(cdsPermissoesWhatsapp);
    IntegerField5.Name := 'IntegerField5';
    IntegerField5.FieldName := 'tabela_sistema.tabela_origem';
    cdsPermissoesWhatsapptabela_id.SetParentComponent(cdsPermissoesWhatsapp);
    cdsPermissoesWhatsapptabela_id.Name := 'cdsPermissoesWhatsapptabela_id';
    cdsPermissoesWhatsapptabela_id.FieldName := 'tabela_id';
    cdsPermissoesWhatsapptabela_id.Required := True;
    dtsPermissoesWhatsapp.SetParentComponent(Self);
    dtsPermissoesWhatsapp.Name := 'dtsPermissoesWhatsapp';
    dtsPermissoesWhatsapp.DataSet := cdsPermissoesWhatsapp;
    dtsPermissoesWhatsapp.Left := 472;
    dtsPermissoesWhatsapp.Top := 264;
    cdsPermissoesMensagens.SetParentComponent(Self);
    cdsPermissoesMensagens.Name := 'cdsPermissoesMensagens';
    cdsPermissoesMensagens.AfterOpen := cdsPermissoesMensagensAfterOpen;
    cdsPermissoesMensagens.EntitySetName := 'Permissoes_Usuario';
    cdsPermissoesMensagens.Connection := DMConnection.ApiConnection;
    cdsPermissoesMensagens.QueryTop := 500;
    cdsPermissoesMensagens.Left := 600;
    cdsPermissoesMensagens.Top := 264;
    IntegerField6.SetParentComponent(cdsPermissoesMensagens);
    IntegerField6.Name := 'IntegerField6';
    IntegerField6.FieldName := 'id';
    IntegerField6.Required := True;
    BooleanField9.SetParentComponent(cdsPermissoesMensagens);
    BooleanField9.Name := 'BooleanField9';
    BooleanField9.FieldName := 'visualizar';
    BooleanField9.Required := True;
    BooleanField10.SetParentComponent(cdsPermissoesMensagens);
    BooleanField10.Name := 'BooleanField10';
    BooleanField10.FieldName := 'inserir';
    BooleanField10.Required := True;
    BooleanField11.SetParentComponent(cdsPermissoesMensagens);
    BooleanField11.Name := 'BooleanField11';
    BooleanField11.FieldName := 'alterar';
    BooleanField11.Required := True;
    BooleanField12.SetParentComponent(cdsPermissoesMensagens);
    BooleanField12.Name := 'BooleanField12';
    BooleanField12.FieldName := 'excluir';
    BooleanField12.Required := True;
    StringField3.SetParentComponent(cdsPermissoesMensagens);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'tabela_sistema.tabela';
    IntegerField7.SetParentComponent(cdsPermissoesMensagens);
    IntegerField7.Name := 'IntegerField7';
    IntegerField7.FieldName := 'usuario_id';
    IntegerField7.Required := True;
    IntegerField8.SetParentComponent(cdsPermissoesMensagens);
    IntegerField8.Name := 'IntegerField8';
    IntegerField8.FieldName := 'tabela_sistema.tabela_origem';
    cdsPermissoesMensagenstabela_id.SetParentComponent(cdsPermissoesMensagens);
    cdsPermissoesMensagenstabela_id.Name := 'cdsPermissoesMensagenstabela_id';
    cdsPermissoesMensagenstabela_id.FieldName := 'tabela_id';
    cdsPermissoesMensagenstabela_id.Required := True;
    dtsPermissoesMensagens.SetParentComponent(Self);
    dtsPermissoesMensagens.Name := 'dtsPermissoesMensagens';
    dtsPermissoesMensagens.DataSet := cdsPermissoesMensagens;
    dtsPermissoesMensagens.Left := 664;
    dtsPermissoesMensagens.Top := 264;
    tmrConsultaService.SetParentComponent(Self);
    tmrConsultaService.Name := 'tmrConsultaService';
    tmrConsultaService.Enabled := False;
    SetEvent(tmrConsultaService, Self, 'OnTimer', 'tmrConsultaServiceTimer');
    tmrConsultaService.Left := 72;
    tmrConsultaService.Top := 88;
    tmrConsultaFacilSistemas.SetParentComponent(Self);
    tmrConsultaFacilSistemas.Name := 'tmrConsultaFacilSistemas';
    tmrConsultaFacilSistemas.Enabled := False;
    SetEvent(tmrConsultaFacilSistemas, Self, 'OnTimer', 'tmrConsultaFacilSistemasTimer');
    tmrConsultaFacilSistemas.Left := 272;
    tmrConsultaFacilSistemas.Top := 88;
    XDataClientSalvarPermissoes.SetParentComponent(Self);
    XDataClientSalvarPermissoes.Name := 'XDataClientSalvarPermissoes';
    XDataClientSalvarPermissoes.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSalvarPermissoes, Self, 'OnLoad', 'XDataClientSalvarPermissoesLoad');
    SetEvent(XDataClientSalvarPermissoes, Self, 'OnError', 'XDataClientSalvarPermissoesError');
    XDataClientSalvarPermissoes.Left := 504;
    XDataClientSalvarPermissoes.Top := 328;
  finally
    lblDescricaoPermissao.AfterLoadDFMValues;
    pnlPermissoesFacil.AfterLoadDFMValues;
    tblPermissoesFacilSistemas.AfterLoadDFMValues;
    pnlPermissoesService.AfterLoadDFMValues;
    tblPermissoesService.AfterLoadDFMValues;
    btnSalvarPermissoes.AfterLoadDFMValues;
    edtPesquisarFacilSistemas.AfterLoadDFMValues;
    edtPesquisarService.AfterLoadDFMValues;
    btnService.AfterLoadDFMValues;
    btnFacilSistemas.AfterLoadDFMValues;
    pnlWhatsapp.AfterLoadDFMValues;
    tblPermissoesWhatsapp.AfterLoadDFMValues;
    btnWhatsapp.AfterLoadDFMValues;
    pnlMensagens.AfterLoadDFMValues;
    tblPermissoesMensagens.AfterLoadDFMValues;
    btnMensagens.AfterLoadDFMValues;
    cdsPermissoesService.AfterLoadDFMValues;
    cdsPermissoesServiceid.AfterLoadDFMValues;
    cdsPermissoesServicevisualizar.AfterLoadDFMValues;
    cdsPermissoesServiceinserir.AfterLoadDFMValues;
    cdsPermissoesServicealterar.AfterLoadDFMValues;
    cdsPermissoesServiceexcluir.AfterLoadDFMValues;
    cdsPermissoesServicetabela_sistematabela.AfterLoadDFMValues;
    cdsPermissoesServiceusuario_id.AfterLoadDFMValues;
    cdsPermissoesServicetabela_sistematabela_origem.AfterLoadDFMValues;
    cdsPermissoesServicetabela_id.AfterLoadDFMValues;
    dtsPermissoesService.AfterLoadDFMValues;
    cdsPermissoesFacilSistemas.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    BooleanField2.AfterLoadDFMValues;
    BooleanField3.AfterLoadDFMValues;
    BooleanField4.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    IntegerField2.AfterLoadDFMValues;
    cdsPermissoesFacilSistemastabela_sistematabela_origem.AfterLoadDFMValues;
    cdsPermissoesFacilSistemastabela_id.AfterLoadDFMValues;
    dtsPermissoesFacilSistemas.AfterLoadDFMValues;
    cdsPermissoesWhatsapp.AfterLoadDFMValues;
    IntegerField3.AfterLoadDFMValues;
    BooleanField5.AfterLoadDFMValues;
    BooleanField6.AfterLoadDFMValues;
    BooleanField7.AfterLoadDFMValues;
    BooleanField8.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    IntegerField4.AfterLoadDFMValues;
    IntegerField5.AfterLoadDFMValues;
    cdsPermissoesWhatsapptabela_id.AfterLoadDFMValues;
    dtsPermissoesWhatsapp.AfterLoadDFMValues;
    cdsPermissoesMensagens.AfterLoadDFMValues;
    IntegerField6.AfterLoadDFMValues;
    BooleanField9.AfterLoadDFMValues;
    BooleanField10.AfterLoadDFMValues;
    BooleanField11.AfterLoadDFMValues;
    BooleanField12.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    IntegerField7.AfterLoadDFMValues;
    IntegerField8.AfterLoadDFMValues;
    cdsPermissoesMensagenstabela_id.AfterLoadDFMValues;
    dtsPermissoesMensagens.AfterLoadDFMValues;
    tmrConsultaService.AfterLoadDFMValues;
    tmrConsultaFacilSistemas.AfterLoadDFMValues;
    XDataClientSalvarPermissoes.AfterLoadDFMValues;
  end;
end;

end.
